import { createReducer } from '../helpers';

import { TableActionTypes, GeneralActionTypes } from '../actions/types';
import { TableReducerHandlers, GeneralReducerHandlers } from './handlers';
import { PAGINATION } from '../../../../shared/constants';

const initialState = {
  pagination: {
    pageIndex: PAGINATION.pageIndex,
    pageSize: PAGINATION.pageSize,
    pageCount: 0,
    rowsTotalCount: 0,
  },
  sortBy: [],
};

const tableReducer = createReducer(
  initialState,
  {
    [GeneralActionTypes.resetStore]: GeneralReducerHandlers.resetStore(initialState),
    [TableActionTypes.setPagination]: TableReducerHandlers.setPagination,
    [TableActionTypes.setSortBy]: TableReducerHandlers.setSortBy,
  },
);

export default tableReducer;
